import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cf75bfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "申请开票", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-arrow-right-svg arrow" }, null, -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = { class: "main" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bill-tips fix-title-box van-hairline--bottom" }, null, -1))
const _hoisted_6 = { class: "bill-detail" }
const _hoisted_7 = { class: "item-title" }
const _hoisted_8 = { class: "item-num" }
const _hoisted_9 = { class: "price" }
const _hoisted_10 = { class: "bill-total" }
const _hoisted_11 = {
  key: 0,
  class: "total-price"
}
const _hoisted_12 = { class: "price" }
const _hoisted_13 = {
  key: 1,
  class: "free"
}

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import BlockkWrapper from './block-wrap.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail-bill-block',
  props: {
    payInfo: null,
    isPayStatus: { type: Boolean },
    isShowBill: { type: Boolean },
    guid: null,
    orderNum: null
  },
  setup(__props: any) {

const props = __props as {
  payInfo: {
    sum: string
    billArr: Array<{
      title: string
      price: string
      sum: string
      num: string
    }>
    isFree: boolean
  }
  isPayStatus: boolean
  isShowBill: boolean
  guid: string
  orderNum: string
};



const propsComputed = computed(() => props)
const $router = useRouter()
const goToBillDetail = () => {
  $router.push({
    name: 'nameplate-reissue-invoice-apply',
    query: {
      guid: propsComputed.value.guid,
      orderNum: propsComputed.value.orderNum,
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockkWrapper, {
    title: "账单费用",
    titleDescription: _unref(propsComputed).isPayStatus ? '请点击页面下方【支付订单】完成在线支付' : ''
  }, {
    right: _withCtx(() => [
      (_unref(propsComputed).isShowBill)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "bill-tip",
            onClick: goToBillDetail
          }, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(propsComputed).payInfo.billArr, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "van-hairline--bottom",
                key: index
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(`${item.title}`), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(`¥ ${item.price} x${item.num}`), 1)
                ]),
                _createElementVNode("div", _hoisted_9, "¥" + _toDisplayString(item.sum), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (!_unref(propsComputed).payInfo.isFree)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createTextVNode(" 付费服务： "),
                _createElementVNode("span", _hoisted_12, "￥" + _toDisplayString(_unref(propsComputed).payInfo.sum), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, "免费服务"))
        ])
      ])
    ]),
    _: 1
  }, 8, ["titleDescription"]))
}
}

})